import BOOKING_ACTION_TYPES from 'constants/bookingActionTypes';
import Booking from 'models/Booking';
import config from 'config/config';

const initialState = () => {
    // Gets the latest booking data from the localstorage
    const lsStateStr = localStorage.getItem(config.BOOKING_DATA);
    if (lsStateStr) {
        const localstorageState = JSON.parse(lsStateStr);
        /**
         * Initialise the booking with data from the localstorage
         * @todo Verify is the same service type selected
         */
        return Booking(localstorageState);
    }

    return Booking();
};

const bookingReducer = (state = initialState(), action) => {
    const { payload } = action;
    switch (action.type) {
        // Updates the booking
        case BOOKING_ACTION_TYPES.update: {
            // Gets the latest booking data from the localstorage
            let newState = {};
            newState = {
                ...state,
                ...payload
            };

            // Stores the new booking data into the localstorage
            const serializedState = JSON.stringify(newState);
            localStorage.setItem(config.BOOKING_DATA, serializedState);
            return newState;
        }
        // Updates the booking
        case BOOKING_ACTION_TYPES.clear:
            localStorage.setItem(config.BOOKING_DATA, '');
            return Booking();
        default:
            return state;
    }
};

export default bookingReducer;
